import styled from 'styled-components';

type BgBorderType = { background: string; border: string };
type TextType = { color: string };

export const SectionCard = styled.div<BgBorderType>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: ${props => props.background};
  border: 1px solid ${props => props.border};
  border-radius: 6px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 100%;
  box-sizing: border-box;
`;

export const SectionTitle = styled.h3<TextType>`
  font-size: 13px;
  font-weight: 700;
  color: ${props => props.color};
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin: 0;
`;
